

export const frontMatter = {
	sidebar_position: 20
};
export const contentTitle = 'Out-parameter and its purpose';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-useful-tips-out-parameter-and-its-purpose-md-816.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    admonition: "admonition",
    code: "code",
    h1: "h1",
    header: "header",
    p: "p",
    pre: "pre",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "out-parameter-and-its-purpose",
        children: "Out-parameter and its purpose"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["In ImageJS several functions have an optional parameter called ", _jsx(_components.code, {
        children: "out"
      }), ".\nYou can use this parameter to select the image you want to use as the output. It helps with memory management by allowing you to write the image into an existing one instead of creating a new copy every time the function is run."]
    }), "\n", _jsx(_components.p, {
      children: "This option is mostly supported for filters which take a single image as input and produce a single image as output."
    }), "\n", _jsxs(_components.p, {
      children: ["For overwriting to be successful, ", _jsx(_components.code, {
        children: "out"
      }), " must be compatible with the width, height, depth and color model of the target image."]
    }), "\n", _jsxs(_components.p, {
      children: ["Here is a simple example of correct and incorrect usage of ", _jsx(_components.code, {
        children: "out"
      }), " while applying ", _jsx(_components.code, {
        children: "invert"
      }), " filter:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "// Creates a gray image of width = 3 and height = 3.\nlet image1 = new Image(3, 3, { colorModel: 'GREY' });\n// Creates an RGB image of width = 1 and height = 3.\nlet image2 = new Image(1, 3, { colorModel: 'RGB' });\n// Image to apply filter on.\nlet testImage = new Image(3, 3, { colorModel: 'GREY' });\n// Correct usage of `out` option. Images are compatible.\ntestImage = testImage.invert({ out: image1 });\nconsole.log(testImage === image1); // true\n\n// Incorrect usage of `out` option. Images have different widths.\ntestImage = testImage.invert({ out: image2 });\n// Throws an error `cannot use out image. Its width property must be 3. Received 1`.\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "If the images are compatible, the source image can be used as an output, as shown in the following example:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "// By default, not passing the out parameter will create and return a new image\ntestImage = image.invert();\nconsole.log(image === testImage); // false\n\n// You can pass the source image as the out parameter to avoid creating a new image\n// The returned image is the out image\ntestImage = image.invert({ out: image });\nconsole.log(image === testImage); // true\n"
      })
    }), "\n", _jsxs(_components.admonition, {
      type: "caution",
      children: [_jsxs(_components.p, {
        children: ["Some functions like ", _jsx(_components.a, {
          href: "https://image-js.github.io/image-js-typescript/functions/convertColor.html",
          title: "github.io link",
          children: _jsx(_components.code, {
            children: "convertColor"
          })
        }), " can have an ", _jsx(_components.code, {
          children: "out"
        }), " parameter but cannot use the source image as the target image, since the function changes the color model of the input image."]
      }), _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "language-ts",
          children: "let image1 = testUtils.createGreyImage([[1, 1, 1]]);\nimage1 = image1.convertColor('RGB', { out: image1 }); // will throw error\n"
        })
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

